/* ============================================================================
   SYMEDIC — caché de las listas desplegables
   Las pantallas piden al servidor sus listas de valores (GET …/lov/agencia,
   …/lov/departamento, …) CADA vez que se abren. Aquí se guardan 10 minutos en
   memoria, y dos pantallas que piden la misma lista a la vez comparten la
   petición. Cualquier escritura (POST, PUT, DELETE) vacía la caché: si se crea
   una agencia, la próxima lista ya la trae. Solo afecta a GET de /lov/ (no a
   las búsquedas /lovl/ ni a ningún dato de pacientes u órdenes).
   ============================================================================ */
(function () {
  if (window.__symCacheListas || typeof window.fetch !== "function") return;
  window.__symCacheListas = true;

  var BASE = (process.env.REACT_APP_ENDPOINT_DATA || "").replace(/\/+$/, "");
  if (!BASE) return;
  var PREFIJO = BASE + "/lov/";
  var DURACION = 10 * 60 * 1000;
  var cache = new Map();
  var original = window.fetch.bind(window);

  window.fetch = function (entrada, opciones) {
    var url = typeof entrada === "string" ? entrada : (entrada && entrada.url) || String(entrada || "");
    var metodo = String((opciones && opciones.method) || (entrada && entrada.method) || "GET").toUpperCase();
    if (metodo !== "GET") {
      cache.clear();
      return original(entrada, opciones);
    }
    if (url.indexOf(PREFIJO) !== 0) return original(entrada, opciones);

    var guardada = cache.get(url);
    if (guardada && Date.now() - guardada.hora < DURACION) {
      return guardada.respuesta.then(function (r) { return r.clone(); });
    }
    var respuesta = original(entrada, opciones).then(function (r) {
      if (!r.ok) cache.delete(url);   // un error no se guarda
      return r;
    }, function (error) {
      cache.delete(url);
      throw error;
    });
    cache.set(url, { hora: Date.now(), respuesta: respuesta });
    return respuesta.then(function (r) { return r.clone(); });
  };
})();
